/* 
 * Vue js Calculator formulas for admin/public
 */

module.exports = ( Vue ) => { 

	Vue.prototype._cf = {

        cost( A, B, coefs, quadrature ) {
            return parseInt( 
                A.coef_size *   //Coef size Sub type
                B.coef_size *   //Coef size quadrature
                quadrature *    //Project quadrature
                coefs.bs *      //Base size
                (coefs.rd/100)        //% Reduction
            );
        },

		costIP( A, B, coefs, full, quadrature ) {

            var result = parseInt( 
                A.coef_size_ip *    //Coef size Sub type
                B.coef_size_ip *    //Coef size quadrature
                quadrature *        //Project quadrature    
                coefs.bsi *         //Base size
                (coefs.rdi/100)     //% Reduction
            );

            //Add videa taxes ( % or min_tax )
            var p = Math.floor( result * coefs.tp / 100 );

            if( p > coefs.mt ) {
            	var tax = p;
            } else {
            	var tax = coefs.mt;
            }
            // - - - - 
            
            result += tax;

            //Check for min-max
            if( result < coefs.miti ) {
                result = coefs.miti + tax;
            } 

            if( coefs.mati > 0 && result > coefs.mati ) {
                result = coefs.mati;
            }

            //Get a more detailed result
            if( typeof full == 'boolean' && full ) {
                var afterTax = result - tax;

                var fp = Math.floor(afterTax * coefs.ipf / 100);
                var sp = Math.floor(afterTax * coefs.ips / 100);
                var tp = Math.floor(afterTax * coefs.ipt / 100);

                return { 
                    total   : result,
                    tax     : tax,
                    afterTax : afterTax,
                    first_place  : fp,
                    second_place : sp,
                    third_place  : tp
                };
            }

            return result;
		},

		timeIP( A, B, coefs ) {
            return parseInt( A.coef_time * B.coef_time * coefs.bt );
		}

	}

}